import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const PageTitle = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 3.5rem;
  margin-bottom: 4.5rem;
  text-align: center;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
`;

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.white};
  padding-top: 3rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 794px;

  &:last-child {
    border-bottom: none;
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: 400;
  font-size: 2rem;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 1.5rem;
  }
`;

export const Description = styled.div<{ isOpen: boolean }>`
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  height: auto;
  line-height: 150%;
  max-height: ${({ isOpen }) => (isOpen ? 'auto' : 0)};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  overflow: hidden;
  font-size: 1.125rem;
  transition:
    max-height 0.25s ease-in-out,
    opacity 0.2s ease-in-out;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 1rem;
  }
`;

export const ChevronImage = styled.img<{ isOpen: boolean }>`
  width: 32px;
  height: 32px;
  rotate: ${({ isOpen }) => (isOpen ? '180deg' : '0deg')};
`;